const config = {
    apiKey: "AIzaSyCNuezlf-EfTZgeVSCkwLuAak-vJgbpLQM",
    authDomain: "firstfirebase-ffcda.firebaseapp.com",
    databaseURL: "https://firstfirebase-ffcda.firebaseio.com",
    projectId: "firstfirebase-ffcda",
    storageBucket: "firstfirebase-ffcda.appspot.com",
    messagingSenderId: "1098293945431",
    appId: "1:1098293945431:web:07e9cdd1bce00e56"
};
export default config;
